import { BadgeField, FullDateField, useFieldHelper, VersionField } from 'framework/ui/field';
import { Typography, Box } from '@mui/material';
import { Badge } from 'framework/ui/mui-builder';
import ProcessAssetsStatusBadgeField from '../shared/fields/ProcessAssetsStatusBadgeField';
import ProcessAssetListActions from '../shared/buttons/actions/ProcessAssetListActions';
import { ProcessAssetsStatusTypes, ProcessAssetsType } from '../types';
import { EmployeeLinkFieldWithNameLoading, EmployeeOfficeField } from 'domain/shared/employee';
import CombineSectionFileTypeField from '../shared/fields/CombineSectionFileTypeField';
import { PROCESS_ASSETS_STATUS } from '../constants';
import { DataGridLayout, Row, TableBodyWithGrouping } from 'framework/list';
import { DownloadFileLinkField } from 'domain/shared/artifact/field';

const PrevProcessAssetRow = () => {
  const { getValue } = useFieldHelper<ProcessAssetsType[]>({ source: 'metadata.previousVersions' });
  const { getValue: getStatus } = useFieldHelper<ProcessAssetsStatusTypes>({ source: 'metadata.status' });
  const previousVersions = getValue() || [];
  const currentStatus = getStatus();

  const isMainActive = currentStatus !== PROCESS_ASSETS_STATUS.PUBLISHED;
  let isShowedActive = !isMainActive;

  return previousVersions.map(item => {
    const showPrevActive = isMainActive && item.metadata.status === PROCESS_ASSETS_STATUS.PUBLISHED && !isShowedActive;

    if (showPrevActive) {
      isShowedActive = true;
    }

    return (
      <Row
        data={item}
        rowProps={{
          sx: {
            opacity: showPrevActive ? '1' : '0.4',
          },
        }}
        buttons={[<ProcessAssetListActions isPrevious />]}
        template={[
          //@ts-ignore template additional types
          <Typography source="space" label="" width="3%" />,
          //@ts-ignore template additional types
          <Typography label="Template" source="space" width="20%" />,
          <VersionField source="metadata.version" label="Version" width="10%" />,
          <Box display="flex" alignItems="center" gap="3px">
            {showPrevActive ? <Badge color="success">Published</Badge> : <Badge color="default">Outdated</Badge>}
          </Box>,
          <EmployeeOfficeField source="metadata.office" label="Office" width="10%" />,
          <CombineSectionFileTypeField source="metadata.section" label="Type" />,
          <EmployeeLinkFieldWithNameLoading source="metadata.owner" label="Owner" />,
          <FullDateField source="metadata.createdAt" label="Create Date" />,
        ]}
      />
    );
  });
};

const ProcessAssetsListContent = () => {
  return (
    <DataGridLayout
      buttons={[<ProcessAssetListActions />]}
      tableBodyComponent={(props: any) => (
        <TableBodyWithGrouping
          {...props}
          childrenSource="metadata.previousVersions"
          toggleSource="space"
          CustomChildTemplate={<PrevProcessAssetRow />}
        />
      )}
    >
      {/* @ts-ignore template additional types */}
      <Typography source="space" label="" width="3%" />
      <DownloadFileLinkField label="Template" showNameSource="metadata.templateName" width="20%" />
      <VersionField source="metadata.version" label="Version" width="10%" />
      <BadgeField
        source="metadata.status"
        label="Status"
        width="10%"
        badges={[<ProcessAssetsStatusBadgeField source="metadata.status" />]}
      />
      <EmployeeOfficeField source="metadata.office" label="Office" width="10%" />
      <CombineSectionFileTypeField source="metadata.section" label="Type" />
      <EmployeeLinkFieldWithNameLoading source="metadata.owner" label="Owner" />
      <FullDateField source="metadata.createdAt" label="Create date" />
    </DataGridLayout>
  );
};

export default ProcessAssetsListContent;
